import React, {
    createContext,
    useState,
    useEffect
} from "react";
import { setSessionExpiredHandler } from "../api/sessionExpiry";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {

    const [user, setUser] = useState(null);

    const [loading, setLoading] = useState(true);

    // بارگذاری اطلاعات کاربر هنگام شروع برنامه
    useEffect(() => {

        const storedUser = localStorage.getItem("user");

        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            const storedToken = localStorage.getItem("token");
            if (parsedUser.isDemo && storedToken === "local-demo-token") {
                localStorage.removeItem("token");
                localStorage.removeItem("user");
            } else {
                setUser(parsedUser);
            }
        }

        setLoading(false);

    }, []);

    // ذخیره اطلاعات کاربر
    // تا وقتی افکت بالا هنوز در حال خواندن اطلاعات از localStorage است
    // (loading=true)، user هنوز به مقدار واقعی‌اش نرسیده؛ اگر این افکت در
    // همان بازه اجرا شود، دقیقاً همان کلیدی را که تازه خوانده شده پاک
    // می‌کند. برای همین تا پایان بارگذاری اولیه چیزی نمی‌نویسد/پاک نمی‌کند.
    useEffect(() => {

        if (loading) return;

        if (user) {

            localStorage.setItem(
                "user",
                JSON.stringify(user)
            );

        } else {

            localStorage.removeItem("user");

        }

    }, [user, loading]);

    // ورود کاربر
    const login = (userData, token) => {

        localStorage.setItem("token", token);

        setUser(userData);

    };

    // خروج کاربر
    const logoutUser = () => {

        setUser(null);

        localStorage.removeItem("token");

        localStorage.removeItem("user");

    };

    // اگر یک درخواست API با ۴۰۱ برگردد (توکن منقضی یا نامعتبر است)، کاربر را
    // به‌صورت تمیز خارج می‌کنیم به‌جای اینکه بی‌صدا در وضعیت "وارد شده اما
    // هیچ درخواستی موفق نیست" باقی بماند.
    useEffect(() => {
        setSessionExpiredHandler(logoutUser);
    }, []);

    return (

        <UserContext.Provider
            value={{
                user,
                loading,
                login,
                logoutUser,
                setUser
            }}
        >

            {children}

        </UserContext.Provider>

    );

};
